import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
  getName,
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";

// Customizable Area Start
import { imgPasswordInVisible, imgPasswordVisible } from "./assets";
// Customizable Area End

export const configJSON = require("./config");

export interface Props {
  navigation: any;
  id: string;
  // Customizable Area Start
  // Customizable Area End
}

interface S {
  // Customizable Area Start
  password: string;
  email: string;
  enablePasswordField: boolean;
  checkedRememberMe: boolean;
  placeHolderEmail: string;
  placeHolderPassword: string;
  imgPasswordVisible: any;
  imgPasswordInVisible: any;
  labelHeader: string;
  btnTxtLogin: string;
  labelRememberMe: string;
  btnTxtSocialLogin: string;
  labelOr: string;
  forgotPassword: string;

  phoneNumber: string;
  phoneError: string;
  countryCodeSelected: string;
  fullPhoneNumber: string;
  callingCode: string;
  flagResponse: FlagResponse;
  // Customizable Area End
}

interface CountryAttributes {
  name: string;
  emoji_flag: string;
  country_code: string;
}

interface CountryFlagResponse {
  id: string;
  type: string;
  attributes: CountryAttributes;
}

interface FlagResponse {
  response: CountryFlagResponse[];
}

interface SS {
  // Customizable Area Start
  id: any;
  navigation: string;
  // Customizable Area End
}

export default class EmailAccountLoginController extends BlockComponent<
  Props,
  S,
  SS
> {
  // Customizable Area Start
  apiEmailLoginCallId: string = "";
  validationApiCallId: string = "";
  emailReg: RegExp;
  labelTitle: string = "";

  handleLoginApiCallId: string = "";
  getCountryFlagsApiCallId: string = "";
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.receive = this.receive.bind(this);

    // Customizable Area Start
    this.subScribedMessages = [
      getName(MessageEnum.CountryCodeMessage),
      getName(MessageEnum.RestAPIResponceMessage),
      getName(MessageEnum.ReciveUserCredentials),
      getName(MessageEnum.NavigationPayLoadMessage),
    ];

    this.state = {
      email: "",
      password: "",
      enablePasswordField: true,
      checkedRememberMe: false,
      placeHolderEmail: configJSON.placeHolderEmail,
      placeHolderPassword: configJSON.placeHolderPassword,
      imgPasswordVisible: configJSON.imgPasswordVisible,
      imgPasswordInVisible: imgPasswordInVisible,
      labelHeader: configJSON.labelHeader,
      btnTxtLogin: configJSON.btnTxtLogin,
      labelRememberMe: configJSON.labelRememberMe,
      btnTxtSocialLogin: configJSON.btnTxtSocialLogin,
      labelOr: configJSON.labelOr,
      forgotPassword: configJSON.forgotPassword,

      phoneNumber: "",
      phoneError: "",
      countryCodeSelected: "DE",
  fullPhoneNumber: "",
  callingCode: "49",
  flagResponse: {
    response: [],
  },
    };

    this.emailReg = new RegExp("");
    this.labelTitle = configJSON.labelTitle;
    // Customizable Area End

    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
  }

  async componentDidMount() {
    this.callGetValidationApi();
    this.send(new Message(getName(MessageEnum.RequestUserCredentials)));
    // Customizable Area Start
    this.getCountryFlags();
   
    const storedCallingCode = sessionStorage.getItem('callingCode') || "49";
    const storedCountryCodeSelected = sessionStorage.getItem('countryCodeSelected') || "DE";
    const storedRawPhoneNumber = sessionStorage.getItem('rawPhoneNumber') || "";

    if(storedCallingCode && storedCountryCodeSelected && storedRawPhoneNumber)
    {
      this.setState({
        callingCode: storedCallingCode,
        countryCodeSelected: storedCountryCodeSelected,
        phoneNumber: storedRawPhoneNumber,
        fullPhoneNumber: `${storedCallingCode}${storedRawPhoneNumber}`,
      })
      sessionStorage.removeItem('callingCode');
      sessionStorage.removeItem('countryCodeSelected');
      sessionStorage.removeItem('rawPhoneNumber');

    }
    // Customizable Area End
  }

  // Customizable Area Start
  btnSocialLoginProps = {
    onPress: () => this.goToSocialLogin(),
  };

  btnEmailLogInProps = {
    onPress: () => this.doEmailLogIn(),
  };

  btnPasswordShowHideProps = {
    onPress: () => {
      this.setState({ enablePasswordField: !this.state.enablePasswordField });
      this.txtInputPasswordProps.secureTextEntry =
        !this.state.enablePasswordField;
      this.btnPasswordShowHideImageProps.source = this.txtInputPasswordProps
        .secureTextEntry
        ? imgPasswordVisible
        : imgPasswordInVisible;
    },
  };

  // Web Event Handling

  getCountryFlags = async () => {
    const headers = {
      "Content-Type": configJSON.validationApiContentType
    };
  
    const getCountryFlagsMsg = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.getCountryFlagsApiCallId = getCountryFlagsMsg.messageId;
  
    getCountryFlagsMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.urlGetCountryFlags
    );
  
    getCountryFlagsMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );
  
    getCountryFlagsMsg.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.validationApiMethodType
    );
  
    runEngine.sendMessage(getCountryFlagsMsg.id, getCountryFlagsMsg);
  };

  handleVerifyButtonClick = () => {
    sessionStorage.setItem('callingCode', this.state.callingCode);
    sessionStorage.setItem('countryCodeSelected', this.state.countryCodeSelected);
    sessionStorage.setItem('rawPhoneNumber', this.state.phoneNumber);
    sessionStorage.setItem('fullPhoneNumber', this.state.fullPhoneNumber);
    this.handleLogin();
  };

  handleLogin = async () => {
    const headers = {
      "Content-Type": configJSON.loginApiContentType
    };
     
     const requestBody = {
         data: {
             type: "logins",
             attributes: {
                 full_phone_number: this.state.fullPhoneNumber,
             }
         }
     };

    const handleLoginMsg = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.handleLoginApiCallId = handleLoginMsg.messageId;

    handleLoginMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.urlhandleLogin
    );

    handleLoginMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );
    handleLoginMsg.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.loginApiMethodType
    );

     
     handleLoginMsg.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(requestBody)
  );

    runEngine.sendMessage(handleLoginMsg.id, handleLoginMsg);
  }

  handleCountryCodeChange = (event: { target: { value: string; }; }) => {
      const selectedCountryCode = event.target.value;
      const selectedCountry = this.state.flagResponse?.response?.find(country => country.id === selectedCountryCode);
      
      if (selectedCountry) {
        this.setState({
          countryCodeSelected: selectedCountryCode,
          callingCode: selectedCountry.attributes.country_code,
          fullPhoneNumber: `${selectedCountry.attributes.country_code}${this.state.phoneNumber}`
        });
      }
    };

    
    handlePhoneNumberChange = (event: { target: { value: string; }; }) => {
      let rawPhone = event.target.value.replace(/\D/g, ""); 
    
      if (rawPhone.length > 10) return; 
    
      this.setState({
        phoneNumber: rawPhone,
        fullPhoneNumber: `${this.state.callingCode}${rawPhone}`
      }, this.validatePhoneNumber);
    };

    
    formatPhoneNumber = (phone: string | any[]) => {
      if (phone.length > 6) {
        return `${phone.slice(0, 3)} ${phone.slice(3, 6)} ${phone.slice(6)}`;
      } else if (phone.length > 3) {
        return `${phone.slice(0, 3)} ${phone.slice(3)}`;
      }
      return phone;
    };
    
    
    validatePhoneNumber = () => {
      this.setState({
        phoneError: this.state.phoneNumber === "" || this.state.phoneNumber.length === 10
          ? "" 
          : "Invalid Phone Number"
      });
    };
    
    
  handleClickShowPassword = () => {
    this.setState({
      enablePasswordField: !this.state.enablePasswordField,
    });
  };

 
  preventInvalidInput = (event: { key: string; preventDefault: () => void; }) => {
    const allowedKeys = ["Backspace", "Tab", "ArrowLeft", "ArrowRight", ];
    
    if (!/^\d$/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  };

  setEmail = (text: string) => {
    this.setState({
      email: text,
    });
  };

  setPassword = (text: string) => {
    this.setState({
      password: text,
    });
  };

  setRememberMe = (value: boolean) => {
    this.setState({ checkedRememberMe: value });
  };

  CustomCheckBoxProps = {
    onChangeValue: (value: boolean) => {
      this.setState({ checkedRememberMe: value });
      this.CustomCheckBoxProps.isChecked = value;
    },
    isChecked: false,
  };

  btnForgotPasswordProps = {
    onPress: () => this.goToForgotPassword(),
  };

  txtInputPasswordProps = {
    onChangeText: (text: string) => {
      this.setState({ password: text });

      //@ts-ignore
      this.txtInputPasswordProps.value = text;
    },
    secureTextEntry: true,
  };

  btnPasswordShowHideImageProps = {
    source: imgPasswordVisible,
  };

  btnRememberMeProps = {
    onPress: () => {
      this.setState({ checkedRememberMe: !this.CustomCheckBoxProps.isChecked });
      this.CustomCheckBoxProps.isChecked = !this.CustomCheckBoxProps.isChecked;
    },
  };

  txtInputEmailWebProps = {
    onChangeText: (text: string) => {
      this.setState({ email: text });

      //@ts-ignore
      this.txtInputEmailProps.value = text;
    },
  };

  txtInputEmailMobileProps = {
    ...this.txtInputEmailWebProps,
    autoCompleteType: "email",
    keyboardType: "email-address",
  };

  txtInputEmailProps = this.isPlatformWeb()
    ? this.txtInputEmailWebProps
    : this.txtInputEmailMobileProps;

  // Customizable Area End

  showNavigationData = (message: Message) => {
    if (getName(MessageEnum.NavigationPayLoadMessage) === message.id) {
    }
  };

  async receive(from: string, message: Message) {
    // Customizable Area Start
    this.showNavigationData(message)
    const messageId = message.id;
  
    if (getName(MessageEnum.ReciveUserCredentials) === messageId) {
      this.handleUserCredentials(message);
    } else if (getName(MessageEnum.RestAPIResponceMessage) === messageId) {
      this.handleRestAPIResponse(message);
    }
    // Customizable Area End
}

  
  private handleUserCredentials(message: Message) {
    const userName = message.getData(getName(MessageEnum.LoginUserName));
    const password = message.getData(getName(MessageEnum.LoginPassword));
    const countryCode = message.getData(getName(MessageEnum.LoginCountryCode));
  
    if (!countryCode && userName && password) {
      this.setState({
        email: userName,
        password: password,
        checkedRememberMe: true,
      });
      //@ts-ignore
      this.txtInputEmailProps.value = userName;
      //@ts-ignore
      this.txtInputPasswordProps.value = password;
      this.CustomCheckBoxProps.isChecked = true;
    }
  }
  
  private handleRestAPIResponse(message: Message) {
    const apiRequestCallId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );
    const responseJson = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );
    const errorResponse = message.getData(
      getName(MessageEnum.RestAPIResponceErrorMessage)
    );
  
    if (apiRequestCallId == null) return;
  
    if (apiRequestCallId === this.validationApiCallId && responseJson !== undefined) {
      this.handleValidationResponse(responseJson);
    }
  
    if (apiRequestCallId === this.apiEmailLoginCallId) {
      this.handleEmailLoginResponse(responseJson, errorResponse);
    }
  
    if (apiRequestCallId === this.handleLoginApiCallId) {
      this.handleHandleLoginResponse(responseJson);
    }

    if (apiRequestCallId === this.getCountryFlagsApiCallId) {
      this.getCountryFlagsResponse(responseJson);
    }
  }

  private getCountryFlagsResponse (responseJson: any){
    this.setState({
      flagResponse: {
        response: responseJson?.data
      }
    });  
  }
  
  private handleValidationResponse(responseJson: any) {
    const arrayholder = responseJson.data;
    if (arrayholder && arrayholder.length > 0) {
      const regexData = arrayholder[0];
      if (regexData?.email_validation_regexp) {
        this.emailReg = new RegExp(regexData.email_validation_regexp);
      }
    }
  }
  
  private handleEmailLoginResponse(responseJson: any, errorResponse: any) {
    if (responseJson?.meta?.token) {
      runEngine.unSubscribeFromMessages(this, this.subScribedMessages);
      this.saveLoggedInUserData(responseJson);
      this.sendLoginSuccessMessage();
      this.openInfoPage();
    } else {
      this.parseApiErrorResponse(responseJson);
      this.sendLoginFailMessage();
    }
    this.parseApiCatchErrorResponse(errorResponse);
  }
  
  private handleHandleLoginResponse(responseJson: any) {
    if (responseJson?.meta) {
      this.setState({ phoneError: "" });

          const payloadData = { fullPhoneNumber: this.state.fullPhoneNumber, showProfile: true, isLogin: true, callingCode: this.state.callingCode, countryCodeSelected: this.state.countryCodeSelected, rawPhoneNumber: this.state.phoneNumber };
          const msgNavigation = new Message(getName(MessageEnum.NavigationMessage));
          msgNavigation.addData(getName(MessageEnum.NavigationTargetMessage), "OTPInputAuth");
          msgNavigation.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
          const raiseMessage: Message = new Message(getName(MessageEnum.NavigationPayLoadMessage));
          raiseMessage.addData(getName(MessageEnum.NavigationPayLoadMessage), payloadData);
          msgNavigation.addData(getName(MessageEnum.NavigationRaiseMessage), raiseMessage);
          this.send(msgNavigation);
          

          
    } else if (responseJson?.errors) {
      let phoneError = "";
      try {
        if (Array.isArray(responseJson.errors)) {
          responseJson.errors.forEach((error: { message: string }) => {
            if (error.message === "Account not found") {
              phoneError = "Phone number does not match our records";
            }
          });
        } else {
          console.error("Unexpected error format:", responseJson);
        }
      } catch (e) {
        console.error("Error parsing response:", e);
      }
      this.setState({ phoneError });
      console.error("Login failed with phone error:", phoneError);
    }
  }
  

  sendLoginFailMessage() {
    const msg: Message = new Message(getName(MessageEnum.LoginFaliureMessage));
    this.send(msg);
  }

  sendLoginSuccessMessage() {
    const msg: Message = new Message(getName(MessageEnum.LoginSuccessMessage));

    msg.addData(getName(MessageEnum.LoginUserName), this.state.email);
    msg.addData(getName(MessageEnum.CountyCodeDataMessage), null);
    msg.addData(getName(MessageEnum.LoginPassword), this.state.password);
    msg.addData(
      getName(MessageEnum.LoginIsRememberMe),
      this.state.checkedRememberMe
    );

    this.send(msg);
  }

  saveLoggedInUserData(responseJson: any) {
    if (responseJson && responseJson.meta && responseJson.meta.token) {
      const msg: Message = new Message(getName(MessageEnum.SessionSaveMessage));

      msg.addData(
        getName(MessageEnum.SessionResponseData),
        JSON.stringify(responseJson)
      );
      msg.addData(
        getName(MessageEnum.SessionResponseToken),
        responseJson.meta.token
      );

      this.send(msg);
    }
  }

  openInfoPage() {
    // Merge Engine - Navigation - btnEmailLogIn - Start
    const msg: Message = new Message(getName(MessageEnum.AccoutLoginSuccess));
    msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    this.send(msg);
    // Merge Engine - Navigation - btnEmailLogIn - End
  }

  goToForgotPassword() {
    // Merge Engine - Navigation - btnForgotPassword - Start
    const msg: Message = new Message(
      getName(MessageEnum.NavigationForgotPasswordMessage)
    );
    msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    msg.addData(getName(MessageEnum.NavigationForgotPasswordPageInfo), "email");
    this.send(msg);
    // Merge Engine - Navigation - btnForgotPassword - End
  }

  goToSocialLogin() {
    const msg: Message = new Message(
      getName(MessageEnum.NavigationSocialLogInMessage)
    );
    msg.addData(getName(MessageEnum.NavigationPropsMessage), this.props);
    this.send(msg);
  }

  doEmailLogIn(): boolean {
    if (
      this.state.email === null ||
      this.state.email.length === 0 ||
      !this.emailReg.test(this.state.email)
    ) {
      this.showAlert("Error", configJSON.errorEmailNotValid);
      return false;
    }

    if (this.state.password === null || this.state.password.length === 0) {
      this.showAlert("Error", configJSON.errorPasswordNotValid);
      return false;
    }

    const header = {
      "Content-Type": configJSON.loginApiContentType,
    };

    const attrs = {
      email: this.state.email,
      password: this.state.password,
    };

    const data = {
      type: "email_account",
      attributes: attrs,
    };

    const httpBody = {
      data: data,
    };

    const requestMessage = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );

    this.apiEmailLoginCallId = requestMessage.messageId;
    requestMessage.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.loginAPiEndPoint
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(httpBody)
    );

    requestMessage.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.loginAPiMethod
    );

    runEngine.sendMessage(requestMessage.id, requestMessage);

    return true;
  }

  callGetValidationApi() {
    const headers = {
      "Content-Type": configJSON.validationApiContentType,
    };

    const getValidationsMsg = new Message(
      getName(MessageEnum.RestAPIRequestMessage)
    );
    this.validationApiCallId = getValidationsMsg.messageId;

    getValidationsMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.urlGetValidations
    );

    getValidationsMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(headers)
    );
    getValidationsMsg.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.validationApiMethodType
    );
    runEngine.sendMessage(getValidationsMsg.id, getValidationsMsg);
  }
}
